import { FC, ReactNode } from "react";
import styles from "./ContentWrapper.module.scss";

interface IContentWrapperProps {
    children: ReactNode,
    context?: 'quiz' | 'game' | 'faq',
    noTopPadding?: boolean;
    noTopBorder?: boolean;
    full?: boolean;
}

export const ContentWrapper: FC<IContentWrapperProps> = ({children, noTopPadding = false, noTopBorder = false, context = "", full = false }) => {
    return (
        <div className={`${styles.contentWrapper} ${noTopPadding && styles.noTopPadding} ${noTopBorder && styles.noTopBorder} ${full && styles.full} ${styles[context] ? styles[context] : ''}`} >
            {children}
        </div>
    );
}
